import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import DisciplineAccessControl from '../common/DisciplineAccessControl';
import HighMastSummarySection from './HighMastSummarySection';

const HighMastDashboard = () => {
  const { user } = useAuth();
  const theme = useTheme();

  const hasOrgWideAccess = user?.permissionScope !== 'network_section';

  return (
    <DisciplineAccessControl requiredDiscipline="Vertical Asset">
    <Box sx={{ maxWidth: '100%' }}>
      <Typography
        variant="h5"
        sx={{ mb: 2, fontWeight: 600, fontSize: { xs: '1.25rem', md: '1.5rem' } }}
      >
        High Mast Infrastructure Overview
      </Typography>

      {hasOrgWideAccess ? (
        <HighMastSummarySection />
      ) : (
        <Box
          sx={{
            p: 4, borderRadius: 2, boxShadow: theme.shadows[1],
            textAlign: 'center', backgroundColor: 'background.paper',
            border: '2px dashed', borderColor: 'divider'
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, color: 'text.secondary' }}>
            Access Restricted
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, mx: 'auto' }}>
            High Mast dashboard requires organization-wide access permissions.
            Please contact your administrator to upgrade your access level.
          </Typography>
        </Box>
      )}
    </Box>
    </DisciplineAccessControl>
  );
};

export default HighMastDashboard;
